import { request } from './utils';

export default class ReturnService {
    static async updateReturn(returnId, data) {
        const response = await request(`/api/returns/${returnId}`, {
            method: 'PATCH',
            data
        });

        return response;
    }

    /** Applies one state event ('process' | 'bounce') to a batch of returns. */
    static async bulkTransitionReturns(returnIds, stateEvent) {
        const response = await request('/api/returns/state_transitions', {
            method: 'POST',
            data: { returnIds, stateEvent }
        });

        return response;
    }
}
